import styled from 'styled-components'

import { _XS_Medium, mainColors } from '@avantstay/backoffice-core'

export const ThreadLink = styled.a`
  ${_XS_Medium};
  color: ${mainColors.accentDark};
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`
